// extracted by mini-css-extract-plugin
export var standaloneTable = "_jq-0";
export var standaloneTableWithBodyFill = "_jq-1";
export var withExtraHeader = "_jq-2";